import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealsFormOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/deal-form/deal-form-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
//declare var SockJS: any;
@Component({
  selector: 'app-deal-form',
  templateUrl: './deal-form.component.html',
  styleUrls: ['./deal-form.component.scss'],
})
export class DealFormComponent extends DealsFormOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
